import ProtectIndex from './protect/Index';
import ProtectSql from './protect/ProtectSql';
import ProtectRecord from './protect/PageRecord';
import ContractIndex from './contract/Index';
import InvoiceIndex from './invoice/Index';
import OrderIndex from './order/Index';
import OrderDetail from './order/PageDetail';
import CustomIndex from './custom/Index';
import ContractApplyIndex from './contract/PageApplyList';

const router = {
  path: 'xianxing',
  breadcrumbName: '先行',
  childRoutes: [
    {
      path: 'protect',
      breadcrumbName: '客户保护',
      indexRoute: { component: ProtectIndex },
      childRoutes: [
        {
          path: 'sql',
          breadcrumbName: '保护查询',
          indexRoute: { component: ProtectSql },
        },
        {
          path: 'record',
          breadcrumbName: '保护记录',
          indexRoute: { component: ProtectRecord },
        },
      ],
    },
    {
      path: 'contract',
      breadcrumbName: '合同管理',
      indexRoute: { component: ContractIndex },
      childRoutes: [
        {
          path: 'apply',
          breadcrumbName: '合同申请列表',
          indexRoute: { component: ContractApplyIndex },
        },
      ],
    },
    {
      path: 'invoice',
      breadcrumbName: '发票管理',
      indexRoute: { component: InvoiceIndex },
    },
    {
      path: 'order',
      breadcrumbName: '订单查询',
      indexRoute: { component: OrderIndex },
      childRoutes: [
        {
          path: ':orderUuid/detail',
          breadcrumbName: '订单详情',
          indexRoute: { component: OrderDetail },
        },
      ],
    },
    {
      path: 'custom',
      breadcrumbName: '意向客户查询',
      indexRoute: { component: CustomIndex },
    },
  ],
};

export default router;



// WEBPACK FOOTER //
// ./src/components/xianxing/router.js